module.exports = __webpack_public_path__ + "images/emoji/steam_locomotive.02ca8d583a6e216cf507.png";